
export const emojiDuoFuXiong = {
    label: '多福熊',
    height: 90,
    width: 90,
    path:"/upload/facetime/duofuxing/",
    range:[[20210101,20210112]]
   
    // items: [
    //     {
    //         'not': 20210101,
    //         'id': 20210101,
    //         'image': '/upload/facetime/duofuxing/20210101.gif',
    //         'title': '擦地',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210101)',
            
    //         'GroupID': 202101
    //     },
    //     {
    //         'not': 20210102,
    //         'id': 20210102,
    //         'image': '/upload/facetime/duofuxing/20210102.gif',
    //         'title': '点赞',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210102)',
            
    //         'GroupID': 202101
    //     },
    //     {
    //         'not': 20210103,
    //         'id': 20210103,
    //         'image': '/upload/facetime/duofuxing/20210103.gif',
    //         'title': '绝望',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210103)',
            
    //         'GroupID': 202101
    //     },
    //     {
    //         'not': 20210104,
    //         'id': 20210104,
    //         'image': '/upload/facetime/duofuxing/20210104.gif',
    //         'title': '挠头',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210104)',
            
    //         'GroupID': 202101
    //     },
    //     {
    //         'not': 20210105,
    //         'id': 20210105,
    //         'image': '/upload/facetime/duofuxing/20210105.gif',
    //         'title': '生气',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210105)',
            
    //         'GroupID': 202101
    //     },
    //     {
    //         'not': 20210106,
    //         'id': 20210106,
    //         'image': '/upload/facetime/duofuxing/20210106.gif',
    //         'title': '跳舞',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210106)',
            
    //         'GroupID': 202101
    //     },
    //     {
    //         'not': 20210107,
    //         'id': 20210107,
    //         'image': '/upload/facetime/duofuxing/20210107.gif',
    //         'title': '头疼',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210107)',
            
    //         'GroupID': 202101
    //     },
    //     {
    //         'not': 20210108,
    //         'id': 20210108,
    //         'image': '/upload/facetime/duofuxing/20210108.gif',
    //         'title': '无聊',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210108)',
            
    //         'GroupID': 202101
    //     },
    //     {
    //         'not': 20210109,
    //         'id': 20210109,
    //         'image': '/upload/facetime/duofuxing/20210109.gif',
    //         'title': '无助',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210109)',
            
    //         'GroupID': 202101
    //     },
    //     {
    //         'not': 20210110,
    //         'id': 20210110,
    //         'image': '/upload/facetime/duofuxing/20210110.gif',
    //         'title': '疑惑',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210110)',
            
    //         'GroupID': 202101
    //     },
    //     {
    //         'not': 20210111,
    //         'id': 20210111,
    //         'image': '/upload/facetime/duofuxing/20210111.gif',
    //         'title': '犹豫',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210111)',
            
    //         'GroupID': 202101
    //     },
    //     {
    //         'not': 20210112,
    //         'id': 20210112,
    //         'image': '/upload/facetime/duofuxing/20210112.gif',
    //         'title': '再见',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210112)',
            
    //         'GroupID': 202101
    //     },
    // ]
}
